import XHR from '@/request/http'
const $h = new XHR()
// url
const url = {
    lists:'/admin/v1/resources/page',
    update:'/admin/v1/resources/update',
    create:'/admin/v1/resources/create',
    del:'/admin/v1/resources/del',
    get:'/admin/v1/resources/get'
}


export async function lists(data)
{
    return $h.request(url.lists,data,'GET')
}

export async function create(data)
{
    return $h.request(url.create,data,'POST')
}

export async function update(data)
{
    return $h.request(url.update,data,'POST')
}

export async function del(data)
{
    return $h.request(url.del,data,'POST')
}

export async function get(id)
{
    return $h.request(url.get,{id:id},'GET')
}

// 当页面为 HTTPS 时，将 http:// 的 URL 升级为 https://，避免 Mixed Content 被浏览器拦截
function upgradeToHttps(targetUrl) {
    if (!targetUrl || typeof targetUrl !== 'string') return targetUrl
    if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:') {
        return targetUrl.replace(/^http:\/\//i, 'https://')
    }
    return targetUrl
}

// 获取文档预览凭证
export async function getPreviewUrl(fileUrl) {
    const res = await $h.request('/admin/v1/file/preview', {fileUrl: fileUrl}, 'GET')
    if (res.code !== 0 || !res.data) {
        throw new Error(res.msg || '获取预览凭证失败')
    }
    // 返回完整数据：previewUrl, accessToken, refreshToken
    return {
        previewUrl: upgradeToHttps(res.data.previewUrl),
        accessToken: res.data.accessToken,
        refreshToken: res.data.refreshToken
    }
}